import type { Apartment } from '../../../api/condominiums';

export function sortApartments(apartments: Apartment[]): Apartment[] {
  return [...apartments].sort((a, b) => {
    const aIsNumeric = /^\d+$/.test(a.number);
    const bIsNumeric = /^\d+$/.test(b.number);

    if (aIsNumeric && bIsNumeric) {
      return parseInt(a.number, 10) - parseInt(b.number, 10);
    }
    if (aIsNumeric && !bIsNumeric) return -1;
    if (!aIsNumeric && bIsNumeric) return 1;

    return a.number.localeCompare(b.number, undefined, { numeric: true, sensitivity: 'base' });
  });
}

export function getTileFontSize(text: string): string {
  const len = text.length;
  if (len <= 3) return 'text-3xl';
  if (len <= 5) return 'text-2xl';
  return 'text-xl';
}
